
import React from "react"
import styled from 'styled-components'
import ArrowLeft from '../images/icons/arrow-left'
import { Link } from "gatsby";

export default function BackButton() {

  return (
    <Layout>
      <Wrap>
        <Button aria-label={'Go back to resume'} to={'/'}>
          <ArrowLeft />
        </Button>
      </Wrap>
    </Layout>
  )
}
const Layout = styled.div`
  display: flex;
  justify-content: center;
`
const Wrap = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 0;
  width: min(1200px, 100vw);
  display: flex;
  justify-content: flex-end;
  height: 0px;
`
const Button = styled(Link)`
  position: absolute;
  bottom: 3rem;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 1.9rem;
  display: flex;
  height: 5rem;
  width: 5rem;
  border-radius: 16px;
  border: 1px solid var(--resume-border-color);
  box-shadow: 0px 10px 30px -8px hsla(0, 0%, 0%, 0.25);
  background-color: hsla(216, 45%, 7%, 0.85);
  backdrop-filter: blur(4px);
  cursor: pointer;
  transition: background-color 200ms var(--ease-out-quart);
  outline: none;
  &:hover, &:focus {
    background-color: hsla(240, 100%, 70%, 0.07);
  }
  &:focus-visible {
    box-shadow: 0px 0px 10px 3px var(--focus-color);
  }
  @media (max-width: 560px) {
    bottom: 2rem;
    margin: 0 2rem;
  }
`
